import { gql } from "@apollo/client";

export const CARE_ASSISTANT_DIPLOMA_FIELDS = gql`
  fragment CareAssistantDiplomaFields on CareAssistantDiploma {
    id
    firstname
    lastname
    personal_number
    date
    author {
      id
      name
      type
    }
    principal
    # principal {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    educator {
      id
      name
      title
      status
      certified
      parentGroups {
        id
        name
        title
        logo2 {
          id
          title
          filename
          filesize
          filetype
          url
        }
        parentGroups {
          id
          name
          title
          logo2 {
            id
            title
            filename
            filesize
            filetype
            url
          }
        }
      }
    }
    credits
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_CARE_ASSISTANT_DIPLOMA = gql`
  query CareAssistantDiploma($id: ID!) {
    certCareAssistantDiploma(id: $id) {
      ...CareAssistantDiplomaFields
    }
  }
  ${CARE_ASSISTANT_DIPLOMA_FIELDS}
`;

export const GET_CARE_ASSISTANT_DIPLOMAS = gql`
  query CareAssistantDiplomas(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetCareAssistantDiplomasOrderByClause]
    $filters: [GetCertFilter]
  ) {
    certCareAssistantDiplomas(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
      filters: $filters
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...CareAssistantDiplomaFields
      }
    }
    allGroups(categories: ["educator"]) {
      id
      title
      parentGroups {
        logo3 {
          id
          title
          url
        }
      }
    }
  }
  ${CARE_ASSISTANT_DIPLOMA_FIELDS}
`;
